export type Profil = {
    'IdPolsterung'?: number;
    'IdGrundfarbe'?: number;
    'IdMotor'?: number;
    'Schadstoffnorm'?: number;
    'Achsen'?: number;
    'Aktenzeichen'?: number;
    'Antrieb'?: number;
    'Sitze'?: number;
    'AUDate'?: number;
    'PreparePreis_netto_brutto'?: number;
    'Ident'?: number;
    'Design'?: number;
    'DateAuslieferung'?: number;
    'Ausstattungen'?: number;
    'Farbe'?: number;
    'VerbrauchAusserorts'?: number;
    'IdValuta'?: number;
    'BasisPreis_netto_brutto'?: number;
    'ManufactYear'?: number;
    'Status'?: number;
    'Bemerkung'?: number;
    'PreDamageDesc'?: number;
    'BestellKey'?: number;
    'Bewerter'?: number;
    'BewertungssystemStr'?: number;
    'BlickfangMobile'?: number;
    'Breite'?: number;
    'CO2Emission'?: number;
    'DateDatenCheck'?: number;
    'DateRechnungOut'?: number;
    'DateRechnungIn'?: number;
    'DesignNeu'?: number;
    'Paket'?: number;
    'DateEingangscheck'?: number;
    'EK_netto_brutto'?: number;
    'Einkaufer'?: number;
    'Envkv'?: number;
    'EZ'?: number;
    'AssEstimation'?: number;
    'UsageEuromobil'?: number;
    'Fahrbereit'?: number;
    'ChassisNo'?: number;
    'Fahrschule'?: number;
    'DateCreated'?: number;
    'KFZBrief'?: number;
    'Kategorie'?: number;
    'IdAufbau'?: number;
    'AktTyp'?: number;
    'Garantie'?: number;
    'DateGekauft'?: number;
    'AdditionalUsage'?: number;
    'Getriebe'?: number;
    'Siegel'?: number;
    'Hersteller'?: number;
    'HerstellerObj'?: number;
    'HSN'?: number;
    'HUDate'?: number;
    'Hubraum'?: number;
    'ResellerPreis_netto_brutto'?: number;
    'ResellerPreis2_netto_brutto'?: number;
    'Hoehe'?: number;
    'DateAufbereitung'?: number;
    'DateLack'?: number;
    'DateWerkstatt'?: number;
    'Innenfarbe'?: number;
    'VerbrauchInnerorts'?: number;
    'RepairPreis_netto_brutto'?: number;
    'Kennzeichen'?: number;
    'Mileage'?: number;
    'VerbrauchKombiniert'?: number;
    'Kommission'?: number;
    'AssKorrektion'?: number;
    'VK_netto_brutto'?: number;
    'DateLackOK'?: number;
    'Lackart'?: number;
    'Leistung'?: number;
    'LetzteBewertung'?: number;
    'Lieferzeit'?: number;
    'Laenge'?: number;
    'Mietwagen'?: number;
    'VKM_netto_brutto'?: number;
    'Modell'?: number;
    'ModellObj'?: number;
    'ModellJahr'?: number;
    'MWST'?: number;
    'Maengel'?: number;
    'DateNachakquise'?: number;
    'Neupreis_netto_brutto'?: number;
    'NummerRechnungOut'?: number;
    'NummerRechnungIn'?: number;
    'NurExport'?: number;
    'NurHaendler'?: number;
    'Nutzlast'?: number;
    'Oldtimer'?: number;
    'DateOptikOK'?: number;
    'Plakette'?: number;
    'Polsterung'?: number;
    'DatePreisOK'?: number;
    'Radstand'?: number;
    'Reifen'?: number;
    'AktReservation'?: number;
    'Scheckheft'?: number;
    'Schlafplaetze'?: number;
    'Parkplatz'?: number;
    'Damages'?: number;
    'SeiteEinsMobile'?: number;
    'UsageElseInfo'?: number;
    'UsageElse'?: number;
    'Standort'?: number;
    'Standtage2'?: number;
    'Standtage1Rechnung'?: number;
    'Standtage1'?: number;
    'Tageszulassung'?: number;
    'Taxi'?: number;
    'DateTechnikOK'?: number;
    'Trackingdaten'?: number;
    'TSN'?: number;
    'Doors'?: number;
    'NumDamages'?: number;
    'DateValuta'?: number;
    'DateVerkaufsfertig'?: number;
    'VK'?: number;
    'DateVerkauft'?: number;
    'Verkaufer'?: number;
    'Verwendung'?: number;
    'Vorbesitzer'?: number;
    'UsageVorfuehrwagen'?: number;
    'PreDamages'?: number;
    'VKWebBrutto'?: number;
    'VKWebd_netto_brutto'?: number;
    'MinderPreis_netto_brutto'?: number;
    'Youngtimer'?: number;
    'DateTakeInPlan'?: number;
    'DateTakeInReal'?: number;
    'ZulGesamtGewicht'?: number;
    'Zustand'?: number;
    'UeberfuehrungsPreis_netto_brutto'?: number;
    'miBewerten'?: number;
    'miListBewertungDAT_EK'?: number;
    'miListBewertungEKVK'?: number;
    'miListBewertungDAT'?: number;
    'miListFinanzierungen'?: number;
    'miFzgAufbereitung'?: number;
    'miFzgLackierung'?: number;
    'miFzgWerkstatt'?: number;
    'miListISO9000'?: number;
    'miFzgKomplett'?: number;
    'miListLeasingrückläufer'?: number;
    'miListVfW'?: number;
    'miListPreisanpassungen'?: number;
    'miListStandtage'?: number;
    'miListValuta'?: number;
    'miHolzAlle'?: number;
    'miTracking'?: number;
    'miPreisfinder'?: number;
    'fzgAngebot'?: number;
    'fzgAusstattung'?: number;
    'Bildbearbeiter'?: number;
    'fzgBilder'?: number;
    'fzgGrunddaten'?: number;
    'fzgUebersicht'?: number;
    'FzgUpload'?: number;
    'fzgHistorie'?: number;
    'fzgISO9000'?: number;
    'fzgKunden'?: number;
    'fzgPreise'?: number;
    'Quellen'?: number;
    'fzgStatistik'?: number;
    'fzgTracking'?: number;
    'fzgMehrdaten'?: number;
    'miStatMyMoPortale'?: number;
    'histBest'?: number;
    'changesGlobal'?: number;
    'changesLokal'?: number;
    'Angebote'?: number;
    'miStatAnfragen'?: number;
    'confAllgemein'?: number;
    'confBenutzer'?: number;
    'confBilder'?: number;
    'confDatenquelle'?: number;
    'confFirma'?: number;
    'confImport'?: number;
    'confPortale'?: number;
    'miSerienAusstattungen'?: number;
    'TableDef'?: number;
    'miKundenmanagement'?: number;
    'statUserOnline'?: number;
    'statClickMobile'?: number;
    'miBestand'?: number;
    'miEKVK'?: number;
    'miStandtage'?: number;
    'soldAllMember'?: number;
    'miVerkauf'?: number;
    'miUploadMymotion'?: number;
    'statUploadMM'?: number;
    'miUploadPortale'?: number;
    'statUploadPortale'?: number;
    'miEditVerkauf'?: number;
    'Topinserat_mobile'?: number;
    'Aktionsfahrzeug'?: number;
    'showSollPreise'?: number;
    'client'?: number;
    'EComm'?: number;
    'LaenderVersion'?: number;
    'miBDC'?: number;
    'Provision'?: number;
    'ProvisionComplete'?: number;
    'ProvisionManuell'?: number;
    'vkliste'?: number;
    'showDetailKosten'?: number;
    'BasisPreis_netto'?: number;
    'PreparePreis_netto'?: number;
    'master'?: number;
    'umbuchen'?: number;
    'umbuchenDatum'?: number;
    'umbuchenPreis'?: number;
    'Obj'?: number;
    'Fahrzeuge'?: number;
    'Firma'?: number;
    'Hinweise'?: number;
    'Hsn'?: number;
    'mailstat'?: number;
    'DateVerfuegbarAb'?: number;
    'Gruppe'?: number;
    'ReservierungBemerkung'?: number;
    'ReservierungBis'?: number;
    'Daten nicht gepflegt'?: number;
    'ResellerPreis_netto'?: number;
    'ResellerPreis2_netto'?: number;
    'RepairPreis_netto'?: number;
    'Jahr'?: number;
    'Kontaktstatus'?: number;
    'Kosten_netto_brutto'?: number;
    'Kraftstoff'?: number;
    'ReservierungKunde'?: number;
    'max. Ebenen'?: number;
    'Portal'?: number;
    'Titel'?: number;
    'AktTypStrDE'?: number;
    'Volltextsuche'?: number;
    'ReservierungVon'?: number;
    'VKWebd_netto'?: number;
    'Weiterleiten an'?: number;
    'MinderPreis_netto'?: number;
    'Zeitraum'?: number;
    'UeberfuehrungsPreis_netto'?: number;
    'Bemerkungen'?: number;
    'Hints'?: number;
    'ToDoAtStart'?: number;
};

export type Rolle =
    | '_Einkaufspreis'
    | 'Administrator'
    | 'Aufbereitung'
    | 'Bewerter'
    | 'Bildbearbeiter'
    | 'Buchhaltung'
    | 'Datenexport'
    | 'Datenimport'
    | 'Disposition'
    | 'eMail-Client'
    | 'eMail-Master'
    | 'Innendienst'
    | 'Internetverantwortlicher'
    | 'Lackierung'
    | 'Qualitätssicherung'
    | 'Umbucher'
    | 'Verkaufsleitung'
    | 'Verkäufer'
    | 'Werkstatt';

const sProfile: Record<Rolle, Profil> = {
    'eMail-Client': {
        IdPolsterung: 1,
        IdGrundfarbe: 1,
        Status: 1,
        IdMotor: 1,
        Schadstoffnorm: 1,
        Achsen: 1,
        Aktenzeichen: 1,
        Antrieb: 1,
        Sitze: 1,
        AUDate: 1,
        PreparePreis_netto_brutto: 1,
        Ident: 1,
        Design: 1,
        DateAuslieferung: 1,
        Ausstattungen: 1,
        Farbe: 1,
        VerbrauchAusserorts: 1,
        IdValuta: 1,
        BasisPreis_netto_brutto: 1,
        ManufactYear: 1,
        Bemerkung: 1,
        PreDamageDesc: 1,
        BestellKey: 1,
        Bewerter: 1,
        BewertungssystemStr: 1,
        BlickfangMobile: 1,
        Breite: 1,
        CO2Emission: 1,
        DateDatenCheck: 1,
        DateRechnungOut: 1,
        DateRechnungIn: 1,
        DesignNeu: 1,
        Paket: 1,
        DateEingangscheck: 1,
        Einkaufer: 1,
        Envkv: 1,
        EZ: 1,
        AssEstimation: 1,
        UsageEuromobil: 1,
        Fahrbereit: 1,
        ChassisNo: 1,
        Fahrschule: 1,
        DateCreated: 1,
        KFZBrief: 1,
        Kategorie: 1,
        IdAufbau: 1,
        AktTyp: 1,
        Garantie: 1,
        DateGekauft: 1,
        AdditionalUsage: 1,
        Getriebe: 1,
        Siegel: 1,
        Hersteller: 1,
        HerstellerObj: 1,
        HSN: 1,
        HUDate: 1,
        Hubraum: 1,
        ResellerPreis_netto_brutto: 1,
        ResellerPreis2_netto_brutto: 1,
        Hoehe: 1,
        DateAufbereitung: 1,
        DateLack: 1,
        DateWerkstatt: 1,
        Innenfarbe: 1,
        VerbrauchInnerorts: 1,
        RepairPreis_netto_brutto: 1,
        Kennzeichen: 1,
        Mileage: 1,
        VerbrauchKombiniert: 1,
        Kommission: 1,
        AssKorrektion: 1,
        VK_netto_brutto: 1,
        DateLackOK: 1,
        Lackart: 1,
        Leistung: 1,
        LetzteBewertung: 1,
        Lieferzeit: 1,
        Laenge: 1,
        Mietwagen: 1,
        VKM_netto_brutto: 1,
        Modell: 1,
        ModellObj: 1,
        ModellJahr: 1,
        MWST: 1,
        Maengel: 1,
        DateNachakquise: 1,
        Neupreis_netto_brutto: 1,
        NummerRechnungOut: 1,
        NummerRechnungIn: 1,
        NurExport: 1,
        NurHaendler: 1,
        Nutzlast: 1,
        Oldtimer: 1,
        DateOptikOK: 1,
        Plakette: 1,
        Polsterung: 1,
        DatePreisOK: 1,
        Radstand: 1,
        Reifen: 1,
        AktReservation: 1,
        Scheckheft: 1,
        Schlafplaetze: 1,
        Parkplatz: 1,
        Damages: 1,
        SeiteEinsMobile: 1,
        UsageElseInfo: 1,
        UsageElse: 1,
        Standort: 1,
        Standtage2: 1,
        Standtage1Rechnung: 1,
        Standtage1: 1,
        Tageszulassung: 1,
        Taxi: 1,
        DateTechnikOK: 1,
        Trackingdaten: 1,
        TSN: 1,
        Doors: 1,
        NumDamages: 1,
        DateValuta: 1,
        DateVerkaufsfertig: 1,
        VK: 1,
        DateVerkauft: 1,
        Verkaufer: 1,
        Verwendung: 1,
        Vorbesitzer: 1,
        UsageVorfuehrwagen: 1,
        PreDamages: 1,
        VKWebBrutto: 1,
        VKWebd_netto_brutto: 1,
        MinderPreis_netto_brutto: 1,
        Youngtimer: 1,
        DateTakeInPlan: 1,
        DateTakeInReal: 1,
        ZulGesamtGewicht: 1,
        Zustand: 1,
        UeberfuehrungsPreis_netto_brutto: 1,
        client: 1,
    },
    'Lackierung': {
        IdPolsterung: 1,
        IdGrundfarbe: 1,
        Status: 1,
        IdMotor: 1,
        Schadstoffnorm: 1,
        Achsen: 1,
        Aktenzeichen: 1,
        Antrieb: 1,
        Sitze: 1,
        AUDate: 1,
        PreparePreis_netto_brutto: 1,
        Ident: 1,
        Design: 1,
        DateAuslieferung: 1,
        Ausstattungen: 1,
        Farbe: 1,
        VerbrauchAusserorts: 1,
        IdValuta: 1,
        BasisPreis_netto_brutto: 1,
        ManufactYear: 1,
        Bemerkung: 1,
        PreDamageDesc: 1,
        BestellKey: 1,
        Bewerter: 1,
        BewertungssystemStr: 1,
        BlickfangMobile: 1,
        Breite: 1,
        CO2Emission: 1,
        DateDatenCheck: 1,
        DateRechnungOut: 1,
        DateRechnungIn: 1,
        DesignNeu: 1,
        Paket: 1,
        DateEingangscheck: 1,
        Einkaufer: 1,
        Envkv: 1,
        EZ: 1,
        AssEstimation: 1,
        UsageEuromobil: 1,
        Fahrbereit: 1,
        ChassisNo: 1,
        Fahrschule: 1,
        DateCreated: 1,
        KFZBrief: 1,
        Kategorie: 1,
        IdAufbau: 1,
        AktTyp: 1,
        Garantie: 1,
        DateGekauft: 1,
        AdditionalUsage: 1,
        Getriebe: 1,
        Siegel: 1,
        Hersteller: 1,
        HerstellerObj: 1,
        HSN: 1,
        HUDate: 1,
        Hubraum: 1,
        ResellerPreis_netto_brutto: 1,
        ResellerPreis2_netto_brutto: 1,
        Hoehe: 1,
        DateAufbereitung: 1,
        DateLack: 15,
        DateWerkstatt: 1,
        Innenfarbe: 1,
        VerbrauchInnerorts: 1,
        RepairPreis_netto_brutto: 1,
        Kennzeichen: 1,
        Mileage: 1,
        VerbrauchKombiniert: 1,
        Kommission: 1,
        AssKorrektion: 1,
        VK_netto_brutto: 1,
        DateLackOK: 15,
        Lackart: 1,
        Leistung: 1,
        LetzteBewertung: 1,
        Lieferzeit: 1,
        Laenge: 1,
        Mietwagen: 1,
        VKM_netto_brutto: 1,
        Modell: 1,
        ModellObj: 1,
        ModellJahr: 1,
        MWST: 1,
        Maengel: 1,
        DateNachakquise: 1,
        Neupreis_netto_brutto: 1,
        NummerRechnungOut: 1,
        NummerRechnungIn: 1,
        NurExport: 1,
        NurHaendler: 1,
        Nutzlast: 1,
        Oldtimer: 1,
        DateOptikOK: 1,
        Plakette: 1,
        Polsterung: 1,
        DatePreisOK: 1,
        Radstand: 1,
        Reifen: 1,
        AktReservation: 1,
        Scheckheft: 1,
        Schlafplaetze: 1,
        Parkplatz: 1,
        Damages: 1,
        SeiteEinsMobile: 1,
        UsageElseInfo: 1,
        UsageElse: 1,
        Standort: 1,
        Standtage2: 1,
        Standtage1Rechnung: 1,
        Standtage1: 1,
        Tageszulassung: 1,
        Taxi: 1,
        DateTechnikOK: 1,
        Trackingdaten: 1,
        TSN: 1,
        Doors: 1,
        NumDamages: 1,
        DateValuta: 1,
        DateVerkaufsfertig: 1,
        VK: 1,
        DateVerkauft: 1,
        Verkaufer: 1,
        Verwendung: 1,
        Vorbesitzer: 1,
        UsageVorfuehrwagen: 1,
        PreDamages: 1,
        VKWebBrutto: 1,
        VKWebd_netto_brutto: 1,
        MinderPreis_netto_brutto: 1,
        Youngtimer: 1,
        DateTakeInPlan: 1,
        DateTakeInReal: 1,
        ZulGesamtGewicht: 1,
        Zustand: 1,
        UeberfuehrungsPreis_netto_brutto: 1,
        miFzgLackierung: 1,
        fzgStatistik: 1,
    },
    'Bildbearbeiter': {
        IdPolsterung: 1,
        IdGrundfarbe: 1,
        Status: 1,
        IdMotor: 1,
        Schadstoffnorm: 1,
        Achsen: 1,
        Aktenzeichen: 1,
        Antrieb: 1,
        Sitze: 1,
        AUDate: 1,
        PreparePreis_netto_brutto: 1,
        Ident: 1,
        Design: 1,
        DateAuslieferung: 1,
        Ausstattungen: 1,
        Farbe: 1,
        VerbrauchAusserorts: 1,
        IdValuta: 1,
        BasisPreis_netto_brutto: 1,
        ManufactYear: 1,
        Bemerkung: 1,
        PreDamageDesc: 1,
        BestellKey: 1,
        Bewerter: 1,
        BewertungssystemStr: 1,
        BlickfangMobile: 1,
        Breite: 1,
        CO2Emission: 1,
        DateDatenCheck: 1,
        DateRechnungOut: 1,
        DateRechnungIn: 1,
        DesignNeu: 1,
        Paket: 1,
        DateEingangscheck: 1,
        EK_netto_brutto: 1,
        Einkaufer: 1,
        Envkv: 1,
        EZ: 1,
        AssEstimation: 1,
        UsageEuromobil: 1,
        Fahrbereit: 1,
        ChassisNo: 1,
        Fahrschule: 1,
        DateCreated: 1,
        KFZBrief: 1,
        Kategorie: 1,
        IdAufbau: 1,
        AktTyp: 1,
        Garantie: 1,
        DateGekauft: 1,
        AdditionalUsage: 1,
        Getriebe: 1,
        Siegel: 1,
        Hersteller: 1,
        HerstellerObj: 1,
        HSN: 1,
        HUDate: 1,
        Hubraum: 1,
        ResellerPreis_netto_brutto: 1,
        ResellerPreis2_netto_brutto: 1,
        Hoehe: 1,
        DateAufbereitung: 1,
        DateLack: 1,
        DateWerkstatt: 1,
        Innenfarbe: 1,
        VerbrauchInnerorts: 1,
        RepairPreis_netto_brutto: 1,
        Kennzeichen: 1,
        Mileage: 1,
        VerbrauchKombiniert: 1,
        Kommission: 1,
        AssKorrektion: 1,
        VK_netto_brutto: 1,
        DateLackOK: 1,
        Lackart: 1,
        Leistung: 1,
        LetzteBewertung: 1,
        Lieferzeit: 1,
        Laenge: 1,
        Mietwagen: 1,
        VKM_netto_brutto: 1,
        Modell: 1,
        ModellObj: 1,
        ModellJahr: 1,
        MWST: 1,
        Maengel: 1,
        DateNachakquise: 1,
        Neupreis_netto_brutto: 1,
        NummerRechnungOut: 1,
        NummerRechnungIn: 1,
        NurExport: 1,
        NurHaendler: 1,
        Nutzlast: 1,
        Oldtimer: 1,
        DateOptikOK: 1,
        Plakette: 1,
        Polsterung: 1,
        DatePreisOK: 1,
        Radstand: 1,
        Reifen: 1,
        AktReservation: 1,
        Scheckheft: 1,
        Schlafplaetze: 1,
        Parkplatz: 1,
        Damages: 1,
        SeiteEinsMobile: 1,
        UsageElseInfo: 1,
        UsageElse: 1,
        Standort: 1,
        Standtage2: 1,
        Standtage1Rechnung: 1,
        Standtage1: 1,
        Tageszulassung: 1,
        Taxi: 1,
        DateTechnikOK: 1,
        Trackingdaten: 1,
        TSN: 1,
        Doors: 1,
        NumDamages: 1,
        DateValuta: 1,
        DateVerkaufsfertig: 1,
        VK: 1,
        DateVerkauft: 1,
        Verkaufer: 1,
        Verwendung: 1,
        Vorbesitzer: 1,
        UsageVorfuehrwagen: 1,
        PreDamages: 1,
        VKWebBrutto: 1,
        VKWebd_netto_brutto: 1,
        MinderPreis_netto_brutto: 1,
        Youngtimer: 1,
        DateTakeInPlan: 1,
        DateTakeInReal: 1,
        ZulGesamtGewicht: 1,
        Zustand: 1,
        UeberfuehrungsPreis_netto_brutto: 1,
        miFzgKomplett: 1,
        Bildbearbeiter: 1,
        fzgBilder: 1,
        confBilder: 1,
    },
    'Verkaufsleitung': {
        IdPolsterung: 15,
        IdGrundfarbe: 15,
        EComm: 15,
        LaenderVersion: 15,
        miBDC: 1,
        Status: 1,
        IdMotor: 15,
        Schadstoffnorm: 15,
        Achsen: 15,
        Aktenzeichen: 15,
        Antrieb: 15,
        Sitze: 15,
        AUDate: 15,
        PreparePreis_netto_brutto: 15,
        Ident: 31,
        Design: 15,
        DateAuslieferung: 15,
        Ausstattungen: 15,
        Farbe: 15,
        VerbrauchAusserorts: 15,
        IdValuta: 15,
        BasisPreis_netto_brutto: 15,
        ManufactYear: 15,
        Bemerkung: 15,
        PreDamageDesc: 15,
        BestellKey: 15,
        Bewerter: 15,
        BewertungssystemStr: 15,
        BlickfangMobile: 15,
        Breite: 15,
        CO2Emission: 15,
        DateDatenCheck: 15,
        DateRechnungOut: 15,
        DateRechnungIn: 15,
        DesignNeu: 15,
        Paket: 15,
        DateEingangscheck: 15,
        EK_netto_brutto: 15,
        Einkaufer: 15,
        Envkv: 15,
        EZ: 15,
        AssEstimation: 15,
        UsageEuromobil: 15,
        Fahrbereit: 15,
        ChassisNo: 15,
        Fahrschule: 15,
        DateCreated: 15,
        KFZBrief: 15,
        Kategorie: 15,
        IdAufbau: 15,
        AktTyp: 15,
        Garantie: 15,
        DateGekauft: 15,
        AdditionalUsage: 15,
        Getriebe: 15,
        Siegel: 15,
        Hersteller: 15,
        HerstellerObj: 15,
        HSN: 15,
        HUDate: 15,
        Hubraum: 15,
        ResellerPreis_netto_brutto: 15,
        ResellerPreis2_netto_brutto: 15,
        Hoehe: 15,
        DateAufbereitung: 15,
        DateLack: 15,
        DateWerkstatt: 15,
        Innenfarbe: 15,
        VerbrauchInnerorts: 15,
        RepairPreis_netto_brutto: 15,
        Kennzeichen: 15,
        Mileage: 15,
        VerbrauchKombiniert: 15,
        Kommission: 15,
        AssKorrektion: 15,
        VK_netto_brutto: 15,
        DateLackOK: 15,
        Lackart: 15,
        Leistung: 15,
        LetzteBewertung: 15,
        Lieferzeit: 15,
        Laenge: 15,
        Mietwagen: 15,
        VKM_netto_brutto: 15,
        Modell: 15,
        ModellObj: 15,
        ModellJahr: 15,
        MWST: 15,
        Maengel: 15,
        DateNachakquise: 15,
        Neupreis_netto_brutto: 15,
        NummerRechnungOut: 15,
        NummerRechnungIn: 15,
        NurExport: 15,
        NurHaendler: 15,
        Nutzlast: 15,
        Oldtimer: 15,
        DateOptikOK: 15,
        Plakette: 15,
        Polsterung: 15,
        DatePreisOK: 15,
        Radstand: 15,
        Reifen: 15,
        AktReservation: 15,
        Scheckheft: 15,
        Schlafplaetze: 15,
        Parkplatz: 15,
        Damages: 15,
        SeiteEinsMobile: 15,
        UsageElseInfo: 15,
        UsageElse: 15,
        Standort: 15,
        Standtage2: 15,
        Standtage1Rechnung: 15,
        Standtage1: 15,
        Tageszulassung: 15,
        Taxi: 15,
        DateTechnikOK: 15,
        Trackingdaten: 15,
        TSN: 15,
        Doors: 15,
        NumDamages: 15,
        DateValuta: 15,
        DateVerkaufsfertig: 15,
        VK: 15,
        DateVerkauft: 15,
        Verkaufer: 15,
        Verwendung: 15,
        Vorbesitzer: 15,
        UsageVorfuehrwagen: 15,
        PreDamages: 15,
        VKWebBrutto: 15,
        VKWebd_netto_brutto: 15,
        MinderPreis_netto_brutto: 15,
        Youngtimer: 15,
        DateTakeInPlan: 15,
        DateTakeInReal: 15,
        ZulGesamtGewicht: 15,
        Zustand: 15,
        UeberfuehrungsPreis_netto_brutto: 15,
        miBewerten: 1,
        miListBewertungDAT_EK: 1,
        miListBewertungEKVK: 1,
        miListBewertungDAT: 1,
        miListFinanzierungen: 1,
        miFzgAufbereitung: 1,
        miFzgLackierung: 1,
        miFzgWerkstatt: 1,
        miListISO9000: 1,
        miFzgKomplett: 1,
        miListLeasingrückläufer: 1,
        miListVfW: 1,
        miListPreisanpassungen: 1,
        miListStandtage: 1,
        miListValuta: 1,
        miHolzAlle: 1,
        miTracking: 1,
        miPreisfinder: 1,
        fzgAngebot: 1,
        fzgAusstattung: 1,
        Bildbearbeiter: 1,
        fzgBilder: 1,
        fzgGrunddaten: 1,
        fzgUebersicht: 1,
        FzgUpload: 1,
        fzgHistorie: 1,
        fzgISO9000: 1,
        fzgKunden: 1,
        fzgPreise: 1,
        fzgStatistik: 1,
        fzgTracking: 1,
        fzgMehrdaten: 1,
        miStatMyMoPortale: 1,
        histBest: 1,
        changesGlobal: 1,
        changesLokal: 1,
        Angebote: 1,
        miStatAnfragen: 1,
        confAllgemein: 1,
        confBenutzer: 1,
        confBilder: 1,
        confDatenquelle: 1,
        confFirma: 1,
        confImport: 1,
        confPortale: 1,
        miSerienAusstattungen: 1,
        TableDef: 1,
        miKundenmanagement: 1,
        Provision: 1,
        ProvisionComplete: 1,
        ProvisionManuell: 1,
        statUserOnline: 1,
        statClickMobile: 1,
        miBestand: 1,
        miEKVK: 1,
        miStandtage: 1,
        soldAllMember: 1,
        miVerkauf: 1,
        vkliste: 1,
        miEditVerkauf: 1,
        Topinserat_mobile: 15,
        Aktionsfahrzeug: 15,
        showSollPreise: 1,
        showDetailKosten: 1,
    },
    'Innendienst': {
        'IdPolsterung': 1,
        'IdGrundfarbe': 1,
        'IdMotor': 1,
        'Schadstoffnorm': 1,
        'Achsen': 1,
        'Aktenzeichen': 1,
        'Antrieb': 1,
        'Sitze': 1,
        'AUDate': 1,
        'PreparePreis_netto_brutto': 1,
        'PreparePreis_netto': 1,
        'Ident': 1,
        'Design': 1,
        'DateAuslieferung': 1,
        'Ausstattungen': 1,
        'Farbe': 1,
        'IdValuta': 1,
        'BasisPreis_netto_brutto': 1,
        'BasisPreis_netto': 1,
        'ManufactYear': 1,
        'ReservierungBemerkung': 1,
        'PreDamageDesc': 1,
        'BestellKey': 1,
        'Bewerter': 1,
        'BewertungssystemStr': 1,
        'ReservierungBis': 1,
        'BlickfangMobile': 1,
        'Breite': 1,
        'CO2Emission': 1,
        'DateDatenCheck': 1,
        'Daten nicht gepflegt': 1,
        'umbuchenDatum': 1,
        'DateRechnungOut': 1,
        'DateRechnungIn': 1,
        'DesignNeu': 1,
        'Paket': 1,
        'DateEingangscheck': 1,
        'EK_netto_brutto': 1,
        'Einkaufer': 1,
        'Envkv': 1,
        'EZ': 1,
        'AssEstimation': 1,
        'UsageEuromobil': 1,
        'Fahrbereit': 1,
        'ChassisNo': 1,
        'Fahrschule': 1,
        'Obj': 1,
        'DateCreated': 1,
        'KFZBrief': 1,
        'Fahrzeuge': 1,
        'Kategorie': 1,
        'IdAufbau': 1,
        'AktTyp': 1,
        'Firma': 1,
        'Garantie': 1,
        'DateGekauft': 1,
        'AdditionalUsage': 1,
        'Getriebe': 1,
        'Siegel': 1,
        'Hersteller': 1,
        'Hinweise': 1,
        'Hsn': 1,
        'HUDate': 1,
        'Hubraum': 1,
        'ResellerPreis_netto_brutto': 1,
        'ResellerPreis_netto': 1,
        'ResellerPreis2_netto_brutto': 1,
        'ResellerPreis2_netto': 1,
        'Hoehe': 1,
        'DateAufbereitung': 1,
        'DateLack': 1,
        'DateWerkstatt': 1,
        'Innenfarbe': 1,
        'RepairPreis_netto_brutto': 1,
        'RepairPreis_netto': 1,
        'Jahr': 1,
        'Kennzeichen': 1,
        'Mileage': 1,
        'Kommission': 1,
        'Kontaktstatus': 1,
        'AssKorrektion': 1,
        'Kosten_netto_brutto': 1,
        'Kraftstoff': 1,
        'ReservierungKunde': 1,
        'VK_netto_brutto': 1,
        'DateLackOK': 1,
        'Lackart': 1,
        'Leistung': 1,
        'LetzteBewertung': 1,
        'Lieferzeit': 1,
        'Laenge': 1,
        'max. Ebenen': 1,
        'Mietwagen': 1,
        'VKM_netto_brutto': 1,
        'Modell': 1,
        'ModellJahr': 1,
        'MWST': 1,
        'Maengel': 1,
        'DateNachakquise': 1,
        'Neupreis_netto_brutto': 1,
        'NummerRechnungOut': 1,
        'NummerRechnungIn': 1,
        'NurExport': 1,
        'NurHaendler': 1,
        'Nutzlast': 1,
        'Oldtimer': 1,
        'DateOptikOK': 1,
        'Plakette': 1,
        'Polsterung': 1,
        'Portal': 1,
        'umbuchenPreis': 1,
        'DatePreisOK': 1,
        'Radstand': 1,
        'Reifen': 1,
        'AktReservation': 1,
        'Scheckheft': 1,
        'Schlafplaetze': 1,
        'Parkplatz': 1,
        'Damages': 1,
        'SeiteEinsMobile': 1,
        'UsageElseInfo': 1,
        'UsageElse': 1,
        'Standort': 1,
        'Standtage2': 1,
        'Standtage1Rechnung': 1,
        'Standtage1': 1,
        'Status': 1,
        'Tageszulassung': 1,
        'Taxi': 1,
        'DateTechnikOK': 1,
        'Titel': 1,
        'Trackingdaten': 1,
        'TSN': 1,
        'AktTypStrDE': 1,
        'Doors': 1,
        'NumDamages': 1,
        'DateValuta': 1,
        'DateVerkaufsfertig': 1,
        'VK': 1,
        'DateVerkauft': 1,
        'Verkaufer': 1,
        'Verwendung': 1,
        'Volltextsuche': 1,
        'ReservierungVon': 1,
        'Vorbesitzer': 1,
        'UsageVorfuehrwagen': 1,
        'PreDamages': 1,
        'VKWebBrutto': 1,
        'VKWebd_netto_brutto': 1,
        'VKWebd_netto': 1,
        'Weiterleiten an': 1,
        'MinderPreis_netto_brutto': 1,
        'MinderPreis_netto': 1,
        'Youngtimer': 1,
        'Zeitraum': 1,
        'DateTakeInPlan': 1,
        'DateTakeInReal': 1,
        'ZulGesamtGewicht': 1,
        'Zustand': 1,
        'UeberfuehrungsPreis_netto_brutto': 1,
        'UeberfuehrungsPreis_netto': 1,
        'Gruppe': 15,
        'Bemerkungen': 15,
        'Hints': 15,
        'miListFinanzierungen': 1,
        'miFzgAufbereitung': 1,
        'miFzgLackierung': 1,
        'miFzgWerkstatt': 1,
        'miListISO9000': 1,
        'miFzgKomplett': 1,
        'miListLeasingrückläufer': 1,
        'miListVfW': 1,
        'miListPreisanpassungen': 1,
        'miListStandtage': 1,
        'miListValuta': 1,
        'miHolzAlle': 1,
        'miTracking': 1,
        'miPreisfinder': 1,
        'miListBewertungDAT_EK': 1,
        'miListBewertungEKVK': 1,
        'miListBewertungDAT': 1,
        'fzgAngebot': 1,
        'fzgAusstattung': 1,
        'Bildbearbeiter': 1,
        'fzgBilder': 1,
        'fzgGrunddaten': 1,
        'fzgUebersicht': 1,
        'FzgUpload': 1,
        'fzgHistorie': 1,
        'fzgISO9000': 1,
        'fzgPreise': 1,
        'fzgStatistik': 1,
        'fzgTracking': 1,
        'fzgMehrdaten': 1,
        'statUserOnline': 1,
        'statClickMobile': 1,
        'miEKVK': 1,
        'miStandtage': 1,
        'miStatMyMoPortale': 1,
        'changesGlobal': 1,
        'histBest': 1,
        'ToDoAtStart': 1,
        'changesLokal': 1,
        'Angebote': 1,
        'miStatAnfragen': 1,
        'confAllgemein': 1,
        'confBenutzer': 1,
        'confBilder': 1,
        'confDatenquelle': 1,
        'confFirma': 1,
        'confImport': 1,
        'miSerienAusstattungen': 1,
        'TableDef': 1,
        'mailstat': 1,
        'statUploadMM': 1,
        'statUploadPortale': 1,
        'soldAllMember': 1,
        'miVerkauf': 1,
    },
    'Verkäufer': {
        IdPolsterung: 1,
        IdGrundfarbe: 1,
        EComm: 1,
        Status: 1,
        IdMotor: 1,
        Schadstoffnorm: 1,
        Achsen: 1,
        Aktenzeichen: 1,
        Antrieb: 1,
        Sitze: 1,
        AUDate: 1,
        PreparePreis_netto_brutto: 1,
        Ident: 15,
        Design: 1,
        DateAuslieferung: 1,
        Ausstattungen: 1,
        Farbe: 1,
        VerbrauchAusserorts: 1,
        IdValuta: 1,
        BasisPreis_netto_brutto: 1,
        ManufactYear: 1,
        Bemerkung: 1,
        PreDamageDesc: 1,
        BestellKey: 1,
        Bewerter: 1,
        BewertungssystemStr: 1,
        BlickfangMobile: 1,
        Breite: 1,
        CO2Emission: 1,
        DateDatenCheck: 1,
        DateRechnungOut: 1,
        DateRechnungIn: 1,
        DesignNeu: 1,
        Paket: 1,
        DateEingangscheck: 1,
        EK_netto_brutto: 1,
        Einkaufer: 1,
        Envkv: 1,
        EZ: 1,
        AssEstimation: 1,
        UsageEuromobil: 1,
        Fahrbereit: 1,
        ChassisNo: 1,
        Fahrschule: 1,
        DateCreated: 1,
        KFZBrief: 1,
        Kategorie: 1,
        IdAufbau: 1,
        AktTyp: 1,
        Garantie: 1,
        DateGekauft: 1,
        AdditionalUsage: 1,
        Getriebe: 1,
        Siegel: 1,
        Hersteller: 1,
        HerstellerObj: 1,
        HSN: 1,
        HUDate: 1,
        Hubraum: 1,
        ResellerPreis_netto_brutto: 1,
        ResellerPreis2_netto_brutto: 1,
        Hoehe: 1,
        DateAufbereitung: 1,
        DateLack: 1,
        DateWerkstatt: 1,
        Innenfarbe: 1,
        VerbrauchInnerorts: 1,
        RepairPreis_netto_brutto: 1,
        Kennzeichen: 1,
        Mileage: 1,
        VerbrauchKombiniert: 1,
        Kommission: 1,
        AssKorrektion: 1,
        VK_netto_brutto: 1,
        DateLackOK: 1,
        Lackart: 1,
        Leistung: 1,
        LetzteBewertung: 1,
        Lieferzeit: 1,
        Laenge: 1,
        Mietwagen: 1,
        VKM_netto_brutto: 1,
        Modell: 1,
        ModellObj: 1,
        ModellJahr: 1,
        MWST: 1,
        Maengel: 1,
        DateNachakquise: 1,
        Neupreis_netto_brutto: 1,
        NummerRechnungOut: 1,
        NummerRechnungIn: 1,
        NurExport: 1,
        NurHaendler: 1,
        Nutzlast: 1,
        Oldtimer: 1,
        DateOptikOK: 1,
        Plakette: 1,
        Polsterung: 1,
        DatePreisOK: 1,
        Radstand: 1,
        Reifen: 1,
        AktReservation: 1,
        Scheckheft: 1,
        Schlafplaetze: 1,
        Parkplatz: 1,
        Damages: 1,
        SeiteEinsMobile: 1,
        UsageElseInfo: 1,
        UsageElse: 1,
        Standort: 1,
        Standtage2: 1,
        Standtage1Rechnung: 1,
        Standtage1: 1,
        Tageszulassung: 1,
        Taxi: 1,
        DateTechnikOK: 1,
        Trackingdaten: 1,
        TSN: 1,
        Doors: 1,
        NumDamages: 1,
        DateValuta: 1,
        DateVerkaufsfertig: 1,
        VK: 1,
        DateVerkauft: 1,
        Verkaufer: 1,
        Verwendung: 1,
        Vorbesitzer: 1,
        UsageVorfuehrwagen: 1,
        PreDamages: 1,
        VKWebBrutto: 1,
        VKWebd_netto_brutto: 1,
        MinderPreis_netto_brutto: 1,
        Youngtimer: 1,
        DateTakeInPlan: 1,
        DateTakeInReal: 1,
        ZulGesamtGewicht: 1,
        Zustand: 1,
        UeberfuehrungsPreis_netto_brutto: 1,
        miListFinanzierungen: 1,
        miFzgAufbereitung: 1,
        miFzgLackierung: 1,
        miFzgWerkstatt: 1,
        miFzgKomplett: 1,
        miListVfW: 1,
        miPreisfinder: 1,
        fzgAngebot: 1,
        fzgAusstattung: 1,
        fzgBilder: 1,
        fzgGrunddaten: 1,
        fzgUebersicht: 1,
        fzgKunden: 1,
        fzgPreise: 1,
        fzgStatistik: 1,
        fzgTracking: 1,
        fzgMehrdaten: 1,
        Angebote: 1,
        miStatAnfragen: 1,
        miKundenmanagement: 1,
        miVerkauf: 1,
        miEditVerkauf: 1,
        Topinserat_mobile: 1,
        Aktionsfahrzeug: 1,
    },
    '_Einkaufspreis': {
        EK_netto_brutto: 15,
        Farbe: 15,
        Lackart: 15,
        fzgPreise: 1,
    },
    'Aufbereitung': {
        IdPolsterung: 15,
        IdGrundfarbe: 15,
        Status: 1,
        IdMotor: 1,
        Schadstoffnorm: 1,
        Achsen: 1,
        Aktenzeichen: 1,
        Antrieb: 1,
        Sitze: 1,
        AUDate: 1,
        PreparePreis_netto_brutto: 1,
        Ident: 1,
        Design: 1,
        DateAuslieferung: 1,
        Ausstattungen: 1,
        Farbe: 1,
        VerbrauchAusserorts: 1,
        IdValuta: 1,
        BasisPreis_netto_brutto: 1,
        ManufactYear: 1,
        Bemerkung: 1,
        PreDamageDesc: 1,
        BestellKey: 1,
        Bewerter: 1,
        BewertungssystemStr: 1,
        BlickfangMobile: 1,
        Breite: 1,
        CO2Emission: 1,
        DateDatenCheck: 1,
        DateRechnungOut: 1,
        DateRechnungIn: 1,
        DesignNeu: 1,
        Paket: 1,
        DateEingangscheck: 1,
        Einkaufer: 1,
        Envkv: 1,
        EZ: 1,
        AssEstimation: 1,
        UsageEuromobil: 1,
        Fahrbereit: 1,
        ChassisNo: 1,
        Fahrschule: 1,
        DateCreated: 1,
        KFZBrief: 1,
        Kategorie: 1,
        IdAufbau: 1,
        AktTyp: 1,
        Garantie: 1,
        DateGekauft: 1,
        AdditionalUsage: 1,
        Getriebe: 1,
        Siegel: 1,
        Hersteller: 1,
        HerstellerObj: 1,
        HSN: 1,
        HUDate: 1,
        Hubraum: 1,
        ResellerPreis_netto_brutto: 1,
        ResellerPreis2_netto_brutto: 1,
        Hoehe: 1,
        DateAufbereitung: 15,
        DateLack: 1,
        DateWerkstatt: 1,
        Innenfarbe: 1,
        VerbrauchInnerorts: 1,
        RepairPreis_netto_brutto: 1,
        Kennzeichen: 1,
        Mileage: 1,
        VerbrauchKombiniert: 1,
        Kommission: 1,
        AssKorrektion: 1,
        VK_netto_brutto: 1,
        DateLackOK: 1,
        Lackart: 1,
        Leistung: 1,
        LetzteBewertung: 1,
        Lieferzeit: 1,
        Laenge: 1,
        Mietwagen: 1,
        VKM_netto_brutto: 1,
        Modell: 1,
        ModellObj: 1,
        ModellJahr: 1,
        MWST: 1,
        Maengel: 1,
        DateNachakquise: 1,
        Neupreis_netto_brutto: 1,
        NummerRechnungOut: 1,
        NummerRechnungIn: 1,
        NurExport: 1,
        NurHaendler: 1,
        Nutzlast: 1,
        Oldtimer: 1,
        DateOptikOK: 15,
        Plakette: 1,
        Polsterung: 1,
        DatePreisOK: 1,
        Radstand: 1,
        Reifen: 1,
        AktReservation: 1,
        Scheckheft: 1,
        Schlafplaetze: 1,
        Parkplatz: 1,
        Damages: 1,
        SeiteEinsMobile: 1,
        UsageElseInfo: 1,
        UsageElse: 1,
        Standort: 1,
        Standtage2: 1,
        Standtage1Rechnung: 1,
        Standtage1: 1,
        Tageszulassung: 1,
        Taxi: 1,
        DateTechnikOK: 1,
        Trackingdaten: 1,
        TSN: 1,
        Doors: 1,
        NumDamages: 1,
        DateValuta: 1,
        DateVerkaufsfertig: 1,
        VK: 1,
        DateVerkauft: 1,
        Verkaufer: 1,
        Verwendung: 1,
        Vorbesitzer: 1,
        UsageVorfuehrwagen: 1,
        PreDamages: 1,
        VKWebBrutto: 1,
        VKWebd_netto_brutto: 1,
        MinderPreis_netto_brutto: 1,
        Youngtimer: 1,
        DateTakeInPlan: 1,
        DateTakeInReal: 1,
        ZulGesamtGewicht: 1,
        Zustand: 1,
        UeberfuehrungsPreis_netto_brutto: 1,
        miFzgAufbereitung: 1,
        fzgStatistik: 1,
    },
    'Qualitätssicherung': {
        IdPolsterung: 1,
        IdGrundfarbe: 1,
        EComm: 15,
        DateVerfuegbarAb: 15,
        LaenderVersion: 15,
        Status: 1,
        IdMotor: 1,
        Schadstoffnorm: 1,
        Achsen: 1,
        Aktenzeichen: 1,
        Antrieb: 1,
        Sitze: 1,
        AUDate: 1,
        PreparePreis_netto_brutto: 1,
        Ident: 1,
        Design: 1,
        DateAuslieferung: 1,
        Ausstattungen: 1,
        Farbe: 1,
        VerbrauchAusserorts: 1,
        IdValuta: 1,
        BasisPreis_netto_brutto: 1,
        ManufactYear: 1,
        Bemerkung: 1,
        PreDamageDesc: 1,
        BestellKey: 1,
        Bewerter: 1,
        BewertungssystemStr: 1,
        BlickfangMobile: 1,
        Breite: 1,
        CO2Emission: 1,
        DateDatenCheck: 1,
        DateRechnungOut: 1,
        DateRechnungIn: 1,
        DesignNeu: 1,
        Paket: 1,
        DateEingangscheck: 1,
        EK_netto_brutto: 1,
        Einkaufer: 1,
        Envkv: 1,
        EZ: 1,
        AssEstimation: 1,
        UsageEuromobil: 1,
        Fahrbereit: 1,
        ChassisNo: 1,
        Fahrschule: 1,
        DateCreated: 1,
        KFZBrief: 1,
        Kategorie: 1,
        IdAufbau: 1,
        AktTyp: 1,
        Garantie: 1,
        DateGekauft: 1,
        AdditionalUsage: 1,
        Getriebe: 1,
        Siegel: 1,
        Hersteller: 1,
        HerstellerObj: 1,
        HSN: 1,
        HUDate: 1,
        Hubraum: 1,
        ResellerPreis_netto_brutto: 1,
        ResellerPreis2_netto_brutto: 1,
        Hoehe: 1,
        DateAufbereitung: 1,
        DateLack: 1,
        DateWerkstatt: 1,
        Innenfarbe: 1,
        VerbrauchInnerorts: 1,
        RepairPreis_netto_brutto: 1,
        Kennzeichen: 1,
        Mileage: 1,
        VerbrauchKombiniert: 1,
        Kommission: 1,
        AssKorrektion: 1,
        VK_netto_brutto: 1,
        DateLackOK: 1,
        Lackart: 1,
        Leistung: 1,
        LetzteBewertung: 1,
        Lieferzeit: 1,
        Laenge: 1,
        Mietwagen: 1,
        VKM_netto_brutto: 1,
        Modell: 1,
        ModellObj: 1,
        ModellJahr: 1,
        MWST: 1,
        Maengel: 1,
        DateNachakquise: 1,
        Neupreis_netto_brutto: 1,
        NummerRechnungOut: 1,
        NummerRechnungIn: 1,
        NurExport: 1,
        NurHaendler: 1,
        Nutzlast: 1,
        Oldtimer: 1,
        DateOptikOK: 1,
        Plakette: 1,
        Polsterung: 1,
        DatePreisOK: 1,
        Radstand: 1,
        Reifen: 1,
        AktReservation: 1,
        Scheckheft: 1,
        Schlafplaetze: 1,
        Parkplatz: 1,
        Damages: 1,
        SeiteEinsMobile: 1,
        UsageElseInfo: 1,
        UsageElse: 1,
        Standort: 1,
        Standtage2: 1,
        Standtage1Rechnung: 1,
        Standtage1: 1,
        Tageszulassung: 1,
        Taxi: 1,
        DateTechnikOK: 1,
        Trackingdaten: 1,
        TSN: 1,
        Doors: 1,
        NumDamages: 1,
        DateValuta: 1,
        DateVerkaufsfertig: 1,
        VK: 1,
        DateVerkauft: 1,
        Verkaufer: 1,
        Verwendung: 1,
        Vorbesitzer: 1,
        UsageVorfuehrwagen: 1,
        PreDamages: 1,
        VKWebBrutto: 1,
        VKWebd_netto_brutto: 1,
        MinderPreis_netto_brutto: 1,
        Youngtimer: 1,
        DateTakeInPlan: 1,
        DateTakeInReal: 1,
        ZulGesamtGewicht: 1,
        Zustand: 1,
        UeberfuehrungsPreis_netto_brutto: 1,
        miListISO9000: 1,
        miFzgKomplett: 1,
        fzgISO9000: 1,
    },
    'Administrator': {
        IdPolsterung: 15,
        IdGrundfarbe: 15,
        IdMotor: 15,
        Schadstoffnorm: 15,
        Achsen: 15,
        Aktenzeichen: 15,
        Antrieb: 15,
        Sitze: 15,
        AUDate: 15,
        PreparePreis_netto_brutto: 15,
        Ident: 15,
        Design: 15,
        DateAuslieferung: 15,
        Ausstattungen: 15,
        Farbe: 15,
        VerbrauchAusserorts: 15,
        IdValuta: 15,
        BasisPreis_netto_brutto: 15,
        ManufactYear: 15,
        Status: 15,
        Bemerkung: 15,
        PreDamageDesc: 15,
        BestellKey: 15,
        Bewerter: 15,
        BewertungssystemStr: 15,
        BlickfangMobile: 15,
        Breite: 15,
        CO2Emission: 15,
        DateDatenCheck: 15,
        DateRechnungOut: 15,
        DateRechnungIn: 15,
        DesignNeu: 15,
        Paket: 15,
        DateEingangscheck: 15,
        EK_netto_brutto: 15,
        Einkaufer: 15,
        Envkv: 15,
        EZ: 15,
        AssEstimation: 15,
        UsageEuromobil: 15,
        Fahrbereit: 15,
        ChassisNo: 15,
        Fahrschule: 15,
        DateCreated: 15,
        KFZBrief: 15,
        Kategorie: 15,
        IdAufbau: 15,
        AktTyp: 15,
        Garantie: 15,
        DateGekauft: 15,
        AdditionalUsage: 15,
        Getriebe: 15,
        Siegel: 15,
        Hersteller: 15,
        HerstellerObj: 15,
        HSN: 15,
        HUDate: 15,
        Hubraum: 15,
        ResellerPreis_netto_brutto: 15,
        ResellerPreis2_netto_brutto: 15,
        Hoehe: 15,
        DateAufbereitung: 15,
        DateLack: 15,
        DateWerkstatt: 15,
        Innenfarbe: 15,
        VerbrauchInnerorts: 15,
        RepairPreis_netto_brutto: 15,
        Kennzeichen: 15,
        Mileage: 15,
        VerbrauchKombiniert: 15,
        Kommission: 15,
        AssKorrektion: 15,
        VK_netto_brutto: 15,
        DateLackOK: 15,
        Lackart: 15,
        Leistung: 15,
        LetzteBewertung: 15,
        Lieferzeit: 15,
        Laenge: 15,
        Mietwagen: 15,
        VKM_netto_brutto: 15,
        Modell: 15,
        ModellObj: 15,
        ModellJahr: 15,
        MWST: 15,
        Maengel: 15,
        DateNachakquise: 15,
        Neupreis_netto_brutto: 15,
        NummerRechnungOut: 15,
        NummerRechnungIn: 15,
        NurExport: 15,
        NurHaendler: 15,
        Nutzlast: 15,
        Oldtimer: 15,
        DateOptikOK: 15,
        Plakette: 15,
        Polsterung: 15,
        DatePreisOK: 15,
        Radstand: 15,
        Reifen: 15,
        AktReservation: 15,
        Scheckheft: 15,
        Schlafplaetze: 15,
        Parkplatz: 15,
        Damages: 15,
        SeiteEinsMobile: 15,
        UsageElseInfo: 15,
        UsageElse: 15,
        Standort: 15,
        Standtage2: 15,
        Standtage1Rechnung: 15,
        Standtage1: 15,
        Tageszulassung: 15,
        Taxi: 15,
        DateTechnikOK: 15,
        Trackingdaten: 15,
        TSN: 15,
        Doors: 15,
        NumDamages: 15,
        DateValuta: 15,
        DateVerkaufsfertig: 15,
        VK: 15,
        DateVerkauft: 15,
        Verkaufer: 15,
        Verwendung: 15,
        Vorbesitzer: 15,
        UsageVorfuehrwagen: 15,
        PreDamages: 15,
        VKWebBrutto: 15,
        VKWebd_netto_brutto: 15,
        MinderPreis_netto_brutto: 15,
        Youngtimer: 15,
        DateTakeInPlan: 15,
        DateTakeInReal: 15,
        ZulGesamtGewicht: 15,
        Zustand: 15,
        UeberfuehrungsPreis_netto_brutto: 15,
        miBewerten: 1,
        miListBewertungDAT_EK: 1,
        miListBewertungEKVK: 1,
        miListBewertungDAT: 1,
        miListFinanzierungen: 1,
        miFzgAufbereitung: 1,
        miFzgLackierung: 1,
        miFzgWerkstatt: 1,
        miListISO9000: 1,
        miFzgKomplett: 1,
        miListLeasingrückläufer: 1,
        miListVfW: 1,
        miListPreisanpassungen: 1,
        miListStandtage: 1,
        miListValuta: 1,
        miHolzAlle: 1,
        miTracking: 1,
        miPreisfinder: 1,
        fzgAngebot: 1,
        fzgAusstattung: 1,
        Bildbearbeiter: 1,
        fzgBilder: 1,
        fzgGrunddaten: 1,
        fzgUebersicht: 1,
        FzgUpload: 1,
        fzgHistorie: 1,
        fzgISO9000: 1,
        fzgKunden: 1,
        fzgPreise: 1,
        Quellen: 1,
        fzgStatistik: 1,
        fzgTracking: 1,
        fzgMehrdaten: 1,
        miStatMyMoPortale: 1,
        histBest: 1,
        changesGlobal: 1,
        changesLokal: 1,
        Angebote: 1,
        miStatAnfragen: 1,
        confAllgemein: 1,
        confBenutzer: 1,
        confBilder: 1,
        confDatenquelle: 1,
        confFirma: 1,
        confImport: 1,
        confPortale: 1,
        miSerienAusstattungen: 1,
        TableDef: 1,
        miKundenmanagement: 1,
        statUserOnline: 1,
        statClickMobile: 1,
        miBestand: 1,
        miEKVK: 1,
        miStandtage: 1,
        soldAllMember: 1,
        miVerkauf: 1,
        miUploadMymotion: 1,
        statUploadMM: 1,
        miUploadPortale: 1,
        statUploadPortale: 1,
        miEditVerkauf: 1,
        Topinserat_mobile: 15,
        Aktionsfahrzeug: 15,
        showSollPreise: 1,
    },
    'Datenexport': {
        IdPolsterung: 1,
        IdGrundfarbe: 1,
        Status: 1,
        IdMotor: 15,
        Schadstoffnorm: 15,
        Achsen: 15,
        Aktenzeichen: 15,
        Antrieb: 15,
        Sitze: 15,
        AUDate: 15,
        PreparePreis_netto_brutto: 15,
        Ident: 15,
        Design: 15,
        DateAuslieferung: 15,
        Ausstattungen: 15,
        Farbe: 15,
        VerbrauchAusserorts: 15,
        IdValuta: 15,
        BasisPreis_netto_brutto: 15,
        ManufactYear: 15,
        Bemerkung: 15,
        PreDamageDesc: 15,
        BestellKey: 15,
        Bewerter: 15,
        BewertungssystemStr: 15,
        BlickfangMobile: 15,
        Breite: 15,
        CO2Emission: 15,
        DateDatenCheck: 15,
        DateRechnungOut: 15,
        DateRechnungIn: 15,
        DesignNeu: 15,
        Paket: 15,
        DateEingangscheck: 15,
        EK_netto_brutto: 15,
        Einkaufer: 15,
        Envkv: 15,
        EZ: 15,
        AssEstimation: 15,
        UsageEuromobil: 15,
        Fahrbereit: 15,
        ChassisNo: 15,
        Fahrschule: 15,
        DateCreated: 15,
        KFZBrief: 15,
        Kategorie: 15,
        IdAufbau: 15,
        AktTyp: 15,
        Garantie: 15,
        DateGekauft: 15,
        AdditionalUsage: 15,
        Getriebe: 15,
        Siegel: 15,
        Hersteller: 15,
        HerstellerObj: 15,
        HSN: 15,
        HUDate: 15,
        Hubraum: 15,
        ResellerPreis_netto_brutto: 15,
        ResellerPreis2_netto_brutto: 15,
        Hoehe: 15,
        DateAufbereitung: 15,
        DateLack: 15,
        DateWerkstatt: 15,
        Innenfarbe: 15,
        VerbrauchInnerorts: 15,
        RepairPreis_netto_brutto: 15,
        Kennzeichen: 15,
        Mileage: 15,
        VerbrauchKombiniert: 15,
        Kommission: 15,
        AssKorrektion: 15,
        VK_netto_brutto: 15,
        DateLackOK: 15,
        Lackart: 15,
        Leistung: 15,
        LetzteBewertung: 15,
        Lieferzeit: 15,
        Laenge: 15,
        Mietwagen: 15,
        VKM_netto_brutto: 15,
        Modell: 15,
        ModellObj: 15,
        ModellJahr: 15,
        MWST: 15,
        Maengel: 15,
        DateNachakquise: 15,
        Neupreis_netto_brutto: 15,
        NummerRechnungOut: 15,
        NummerRechnungIn: 15,
        NurExport: 15,
        NurHaendler: 15,
        Nutzlast: 15,
        Oldtimer: 15,
        DateOptikOK: 15,
        Plakette: 15,
        Polsterung: 15,
        DatePreisOK: 15,
        Radstand: 15,
        Reifen: 15,
        AktReservation: 15,
        Scheckheft: 15,
        Schlafplaetze: 15,
        Parkplatz: 15,
        Damages: 15,
        SeiteEinsMobile: 15,
        UsageElseInfo: 15,
        UsageElse: 15,
        Standort: 15,
        Standtage2: 15,
        Standtage1Rechnung: 15,
        Standtage1: 15,
        Tageszulassung: 15,
        Taxi: 15,
        DateTechnikOK: 15,
        Trackingdaten: 15,
        TSN: 15,
        Doors: 15,
        NumDamages: 15,
        DateValuta: 15,
        DateVerkaufsfertig: 15,
        VK: 15,
        DateVerkauft: 15,
        Verkaufer: 15,
        Verwendung: 15,
        Vorbesitzer: 15,
        UsageVorfuehrwagen: 15,
        PreDamages: 15,
        VKWebBrutto: 15,
        VKWebd_netto_brutto: 15,
        MinderPreis_netto_brutto: 15,
        Youngtimer: 15,
        DateTakeInPlan: 15,
        DateTakeInReal: 15,
        ZulGesamtGewicht: 15,
        Zustand: 15,
        UeberfuehrungsPreis_netto_brutto: 15,
        miFzgKomplett: 1,
        FzgUpload: 1,
        miUploadPortale: 1,
        statUploadPortale: 1,
        Topinserat_mobile: 15,
        Aktionsfahrzeug: 15,
    },
    'Bewerter': {
        IdPolsterung: 15,
        IdGrundfarbe: 15,
        IdMotor: 1,
        Schadstoffnorm: 1,
        Achsen: 1,
        Aktenzeichen: 1,
        Antrieb: 1,
        Sitze: 1,
        AUDate: 1,
        PreparePreis_netto_brutto: 1,
        Ident: 15,
        Design: 1,
        DateAuslieferung: 1,
        Ausstattungen: 1,
        Farbe: 1,
        IdValuta: 1,
        BasisPreis_netto_brutto: 1,
        ManufactYear: 1,
        PreDamageDesc: 1,
        BestellKey: 1,
        Bewerter: 1,
        BewertungssystemStr: 1,
        BlickfangMobile: 1,
        Breite: 1,
        CO2Emission: 1,
        DateDatenCheck: 1,
        DateRechnungOut: 1,
        DateRechnungIn: 1,
        DesignNeu: 1,
        Paket: 1,
        DateEingangscheck: 1,
        EK_netto_brutto: 1,
        Einkaufer: 1,
        Envkv: 1,
        EZ: 1,
        AssEstimation: 1,
        UsageEuromobil: 1,
        Fahrbereit: 1,
        ChassisNo: 1,
        Fahrschule: 1,
        DateCreated: 1,
        KFZBrief: 1,
        Kategorie: 1,
        IdAufbau: 1,
        AktTyp: 1,
        Garantie: 1,
        DateGekauft: 1,
        AdditionalUsage: 1,
        Getriebe: 1,
        Siegel: 1,
        Hersteller: 1,
        HUDate: 1,
        Hubraum: 1,
        ResellerPreis_netto_brutto: 1,
        ResellerPreis2_netto_brutto: 1,
        Hoehe: 1,
        DateAufbereitung: 1,
        DateLack: 1,
        DateWerkstatt: 1,
        RepairPreis_netto_brutto: 1,
        Kennzeichen: 1,
        Mileage: 1,
        Kommission: 1,
        AssKorrektion: 1,
        VK_netto_brutto: 1,
        DateLackOK: 1,
        Leistung: 1,
        LetzteBewertung: 1,
        Lieferzeit: 1,
        Laenge: 1,
        Mietwagen: 1,
        VKM_netto_brutto: 1,
        Modell: 1,
        ModellJahr: 1,
        MWST: 1,
        Maengel: 1,
        DateNachakquise: 1,
        Neupreis_netto_brutto: 1,
        NummerRechnungOut: 1,
        NummerRechnungIn: 1,
        NurExport: 1,
        NurHaendler: 1,
        Nutzlast: 1,
        Oldtimer: 1,
        DateOptikOK: 1,
        Plakette: 1,
        Polsterung: 1,
        DatePreisOK: 1,
        Radstand: 1,
        Reifen: 1,
        Scheckheft: 1,
        Schlafplaetze: 1,
        Parkplatz: 1,
        Damages: 1,
        SeiteEinsMobile: 1,
        UsageElseInfo: 1,
        UsageElse: 1,
        Standort: 1,
        Standtage2: 1,
        Standtage1Rechnung: 1,
        Standtage1: 1,
        Status: 1,
        Tageszulassung: 1,
        Taxi: 1,
        DateTechnikOK: 1,
        Trackingdaten: 1,
        TSN: 1,
        Doors: 1,
        NumDamages: 1,
        DateValuta: 1,
        DateVerkaufsfertig: 1,
        VK: 1,
        DateVerkauft: 1,
        Verkaufer: 1,
        Verwendung: 1,
        Vorbesitzer: 1,
        UsageVorfuehrwagen: 1,
        PreDamages: 1,
        VKWebBrutto: 1,
        VKWebd_netto_brutto: 1,
        MinderPreis_netto_brutto: 1,
        Youngtimer: 1,
        DateTakeInPlan: 1,
        DateTakeInReal: 1,
        ZulGesamtGewicht: 1,
        Zustand: 1,
        UeberfuehrungsPreis_netto_brutto: 1,
        Gruppe: 15,
        Bemerkungen: 15,
        Hints: 15,
        miListFinanzierungen: 1,
        miFzgAufbereitung: 1,
        miFzgLackierung: 1,
        miFzgWerkstatt: 1,
        miFzgKomplett: 1,
        miListVfW: 1,
        miPreisfinder: 1,
        fzgAngebot: 1,
        fzgAusstattung: 1,
        fzgBilder: 1,
        fzgGrunddaten: 1,
        fzgUebersicht: 1,
        fzgKunden: 1,
        fzgPreise: 1,
        fzgStatistik: 1,
        fzgTracking: 1,
        fzgMehrdaten: 1,
        Angebote: 1,
        miStatAnfragen: 1,
        miEditVerkauf: 1,
        miVerkauf: 1,
    },
    'Disposition': {
        IdPolsterung: 15,
        IdGrundfarbe: 15,
        EComm: 15,
        DateVerfuegbarAb: 15,
        LaenderVersion: 15,
        Status: 1,
        IdMotor: 15,
        Schadstoffnorm: 15,
        Achsen: 15,
        Aktenzeichen: 15,
        Antrieb: 15,
        Sitze: 15,
        AUDate: 15,
        PreparePreis_netto_brutto: 15,
        Ident: 31,
        Design: 15,
        DateAuslieferung: 15,
        Ausstattungen: 15,
        Farbe: 15,
        VerbrauchAusserorts: 15,
        IdValuta: 15,
        BasisPreis_netto_brutto: 15,
        ManufactYear: 15,
        Bemerkung: 15,
        PreDamageDesc: 15,
        BestellKey: 15,
        Bewerter: 15,
        BewertungssystemStr: 15,
        BlickfangMobile: 15,
        Breite: 15,
        CO2Emission: 15,
        DateDatenCheck: 15,
        DateRechnungOut: 15,
        DateRechnungIn: 15,
        DesignNeu: 15,
        Paket: 15,
        DateEingangscheck: 15,
        EK_netto_brutto: 15,
        Einkaufer: 15,
        Envkv: 15,
        EZ: 15,
        AssEstimation: 15,
        UsageEuromobil: 15,
        Fahrbereit: 15,
        ChassisNo: 15,
        Fahrschule: 15,
        DateCreated: 15,
        KFZBrief: 15,
        Kategorie: 15,
        IdAufbau: 15,
        AktTyp: 15,
        Garantie: 15,
        DateGekauft: 15,
        AdditionalUsage: 15,
        Getriebe: 15,
        Siegel: 15,
        Hersteller: 15,
        HerstellerObj: 15,
        HSN: 15,
        HUDate: 15,
        Hubraum: 15,
        ResellerPreis_netto_brutto: 15,
        ResellerPreis2_netto_brutto: 15,
        Hoehe: 15,
        DateAufbereitung: 15,
        DateLack: 15,
        DateWerkstatt: 15,
        Innenfarbe: 15,
        VerbrauchInnerorts: 15,
        RepairPreis_netto_brutto: 15,
        Kennzeichen: 15,
        Mileage: 15,
        VerbrauchKombiniert: 15,
        Kommission: 15,
        AssKorrektion: 15,
        VK_netto_brutto: 15,
        DateLackOK: 15,
        Lackart: 15,
        Leistung: 15,
        LetzteBewertung: 15,
        Lieferzeit: 15,
        Laenge: 15,
        Mietwagen: 15,
        VKM_netto_brutto: 15,
        Modell: 15,
        ModellObj: 15,
        ModellJahr: 15,
        MWST: 15,
        Maengel: 15,
        DateNachakquise: 15,
        Neupreis_netto_brutto: 15,
        NummerRechnungOut: 15,
        NummerRechnungIn: 15,
        NurExport: 15,
        NurHaendler: 15,
        Nutzlast: 15,
        Oldtimer: 15,
        DateOptikOK: 15,
        Plakette: 15,
        Polsterung: 15,
        DatePreisOK: 15,
        Radstand: 15,
        Reifen: 15,
        AktReservation: 15,
        Scheckheft: 15,
        Schlafplaetze: 15,
        Parkplatz: 15,
        Damages: 15,
        SeiteEinsMobile: 15,
        UsageElseInfo: 15,
        UsageElse: 15,
        Standort: 15,
        Standtage2: 15,
        Standtage1Rechnung: 15,
        Standtage1: 15,
        Tageszulassung: 15,
        Taxi: 15,
        DateTechnikOK: 15,
        Trackingdaten: 15,
        TSN: 15,
        Doors: 15,
        NumDamages: 15,
        DateValuta: 15,
        DateVerkaufsfertig: 15,
        VK: 15,
        DateVerkauft: 15,
        Verkaufer: 15,
        Verwendung: 15,
        Vorbesitzer: 15,
        UsageVorfuehrwagen: 15,
        PreDamages: 15,
        VKWebBrutto: 15,
        VKWebd_netto_brutto: 15,
        MinderPreis_netto_brutto: 15,
        Youngtimer: 15,
        DateTakeInPlan: 15,
        DateTakeInReal: 15,
        ZulGesamtGewicht: 15,
        Zustand: 15,
        UeberfuehrungsPreis_netto_brutto: 15,
        miListFinanzierungen: 1,
        miFzgAufbereitung: 1,
        miFzgLackierung: 1,
        miFzgWerkstatt: 1,
        miFzgKomplett: 1,
        miListLeasingrückläufer: 1,
        miListVfW: 1,
        miListPreisanpassungen: 1,
        miListValuta: 1,
        miHolzAlle: 1,
        fzgAusstattung: 1,
        Bildbearbeiter: 1,
        fzgBilder: 1,
        fzgGrunddaten: 1,
        fzgUebersicht: 1,
        fzgHistorie: 1,
        fzgISO9000: 1,
        fzgKunden: 1,
        fzgPreise: 1,
        fzgStatistik: 1,
        fzgMehrdaten: 1,
        histBest: 1,
        changesGlobal: 1,
        changesLokal: 1,
        confBilder: 1,
        miSerienAusstattungen: 1,
        TableDef: 1,
        Provision: 1,
        soldAllMember: 1,
        miVerkauf: 1,
        miEditVerkauf: 1,
    },
    'Internetverantwortlicher': {
        IdPolsterung: 1,
        IdGrundfarbe: 1,
        Status: 1,
        IdMotor: 15,
        Schadstoffnorm: 15,
        Achsen: 15,
        Aktenzeichen: 15,
        Antrieb: 15,
        Sitze: 15,
        AUDate: 15,
        PreparePreis_netto_brutto: 15,
        Ident: 31,
        Design: 15,
        DateAuslieferung: 15,
        Ausstattungen: 15,
        Farbe: 15,
        VerbrauchAusserorts: 15,
        IdValuta: 15,
        BasisPreis_netto_brutto: 15,
        ManufactYear: 15,
        Bemerkung: 15,
        PreDamageDesc: 15,
        BestellKey: 15,
        Bewerter: 15,
        BewertungssystemStr: 15,
        BlickfangMobile: 15,
        Breite: 15,
        CO2Emission: 15,
        DateDatenCheck: 15,
        DateRechnungOut: 15,
        DateRechnungIn: 15,
        DesignNeu: 15,
        Paket: 15,
        DateEingangscheck: 15,
        EK_netto_brutto: 15,
        Einkaufer: 15,
        Envkv: 15,
        EZ: 15,
        AssEstimation: 15,
        UsageEuromobil: 15,
        Fahrbereit: 15,
        ChassisNo: 15,
        Fahrschule: 15,
        DateCreated: 15,
        KFZBrief: 15,
        Kategorie: 15,
        IdAufbau: 15,
        AktTyp: 15,
        Garantie: 15,
        DateGekauft: 15,
        AdditionalUsage: 15,
        Getriebe: 15,
        Siegel: 15,
        Hersteller: 15,
        HerstellerObj: 15,
        HSN: 15,
        HUDate: 15,
        Hubraum: 15,
        ResellerPreis_netto_brutto: 15,
        ResellerPreis2_netto_brutto: 15,
        Hoehe: 15,
        DateAufbereitung: 15,
        DateLack: 15,
        DateWerkstatt: 15,
        Innenfarbe: 15,
        VerbrauchInnerorts: 15,
        RepairPreis_netto_brutto: 15,
        Kennzeichen: 15,
        Mileage: 15,
        VerbrauchKombiniert: 15,
        Kommission: 15,
        AssKorrektion: 15,
        VK_netto_brutto: 15,
        DateLackOK: 15,
        Lackart: 15,
        Leistung: 15,
        LetzteBewertung: 15,
        Lieferzeit: 15,
        Laenge: 15,
        Mietwagen: 15,
        VKM_netto_brutto: 15,
        Modell: 15,
        ModellObj: 15,
        ModellJahr: 15,
        MWST: 15,
        Maengel: 15,
        DateNachakquise: 15,
        Neupreis_netto_brutto: 15,
        NummerRechnungOut: 15,
        NummerRechnungIn: 15,
        NurExport: 15,
        NurHaendler: 15,
        Nutzlast: 15,
        Oldtimer: 15,
        DateOptikOK: 15,
        Plakette: 15,
        Polsterung: 15,
        DatePreisOK: 15,
        Radstand: 15,
        Reifen: 15,
        AktReservation: 15,
        Scheckheft: 15,
        Schlafplaetze: 15,
        Parkplatz: 15,
        Damages: 15,
        SeiteEinsMobile: 15,
        UsageElseInfo: 15,
        UsageElse: 15,
        Standort: 15,
        Standtage2: 15,
        Standtage1Rechnung: 15,
        Standtage1: 15,
        Tageszulassung: 15,
        Taxi: 15,
        DateTechnikOK: 15,
        Trackingdaten: 15,
        TSN: 15,
        Doors: 15,
        NumDamages: 15,
        DateValuta: 15,
        DateVerkaufsfertig: 15,
        VK: 15,
        DateVerkauft: 15,
        Verkaufer: 15,
        Verwendung: 15,
        Vorbesitzer: 15,
        UsageVorfuehrwagen: 15,
        PreDamages: 15,
        VKWebBrutto: 15,
        VKWebd_netto_brutto: 15,
        MinderPreis_netto_brutto: 15,
        Youngtimer: 15,
        DateTakeInPlan: 15,
        DateTakeInReal: 15,
        ZulGesamtGewicht: 15,
        Zustand: 15,
        UeberfuehrungsPreis_netto_brutto: 15,
        miListFinanzierungen: 1,
        miFzgKomplett: 1,
        miListStandtage: 1,
        miHolzAlle: 1,
        miTracking: 1,
        miPreisfinder: 1,
        fzgAngebot: 1,
        fzgAusstattung: 1,
        Bildbearbeiter: 1,
        fzgBilder: 1,
        fzgGrunddaten: 1,
        fzgUebersicht: 1,
        FzgUpload: 1,
        fzgHistorie: 1,
        fzgKunden: 1,
        fzgPreise: 1,
        fzgStatistik: 1,
        fzgTracking: 1,
        fzgMehrdaten: 1,
        miStatMyMoPortale: 1,
        changesLokal: 1,
        Angebote: 1,
        miStatAnfragen: 1,
        confAllgemein: 1,
        confBilder: 1,
        confPortale: 1,
        miSerienAusstattungen: 1,
        TableDef: 1,
        miKundenmanagement: 1,
        statClickMobile: 1,
        miUploadMymotion: 1,
        statUploadMM: 1,
        miUploadPortale: 1,
        statUploadPortale: 1,
        Topinserat_mobile: 15,
        Aktionsfahrzeug: 15,
    },
    'Werkstatt': {
        IdPolsterung: 1,
        IdGrundfarbe: 1,
        IdMotor: 1,
        Schadstoffnorm: 1,
        Achsen: 1,
        Aktenzeichen: 1,
        Antrieb: 1,
        Sitze: 1,
        AUDate: 1,
        PreparePreis_netto_brutto: 1,
        Ident: 1,
        Design: 1,
        DateAuslieferung: 1,
        Ausstattungen: 1,
        Farbe: 1,
        VerbrauchAusserorts: 1,
        IdValuta: 1,
        BasisPreis_netto_brutto: 1,
        ManufactYear: 1,
        Bemerkung: 1,
        PreDamageDesc: 1,
        BestellKey: 1,
        Bewerter: 1,
        BewertungssystemStr: 1,
        BlickfangMobile: 1,
        Breite: 1,
        CO2Emission: 1,
        DateDatenCheck: 1,
        DateRechnungOut: 1,
        DateRechnungIn: 1,
        DesignNeu: 1,
        Paket: 1,
        DateEingangscheck: 1,
        Einkaufer: 1,
        Envkv: 1,
        EZ: 1,
        AssEstimation: 1,
        UsageEuromobil: 1,
        Fahrbereit: 1,
        ChassisNo: 1,
        Fahrschule: 1,
        DateCreated: 1,
        KFZBrief: 1,
        Kategorie: 1,
        IdAufbau: 1,
        AktTyp: 1,
        Garantie: 1,
        DateGekauft: 1,
        AdditionalUsage: 1,
        Getriebe: 1,
        Siegel: 1,
        Hersteller: 1,
        HerstellerObj: 1,
        HSN: 1,
        HUDate: 1,
        Hubraum: 1,
        ResellerPreis_netto_brutto: 1,
        ResellerPreis2_netto_brutto: 1,
        Hoehe: 1,
        DateAufbereitung: 1,
        DateLack: 1,
        DateWerkstatt: 15,
        Innenfarbe: 1,
        VerbrauchInnerorts: 1,
        RepairPreis_netto_brutto: 1,
        Kennzeichen: 1,
        Mileage: 1,
        VerbrauchKombiniert: 1,
        Kommission: 1,
        AssKorrektion: 1,
        VK_netto_brutto: 1,
        DateLackOK: 1,
        Lackart: 1,
        Leistung: 1,
        LetzteBewertung: 1,
        Lieferzeit: 1,
        Laenge: 1,
        Mietwagen: 1,
        VKM_netto_brutto: 1,
        Modell: 1,
        ModellObj: 1,
        ModellJahr: 1,
        MWST: 1,
        Maengel: 1,
        DateNachakquise: 1,
        Neupreis_netto_brutto: 1,
        NummerRechnungOut: 1,
        NummerRechnungIn: 1,
        NurExport: 1,
        NurHaendler: 1,
        Nutzlast: 1,
        Oldtimer: 1,
        DateOptikOK: 1,
        Plakette: 1,
        Polsterung: 1,
        DatePreisOK: 1,
        Radstand: 1,
        Reifen: 1,
        AktReservation: 1,
        Scheckheft: 1,
        Schlafplaetze: 1,
        Parkplatz: 1,
        Damages: 1,
        SeiteEinsMobile: 1,
        UsageElseInfo: 1,
        UsageElse: 1,
        Standort: 1,
        Standtage2: 1,
        Standtage1Rechnung: 1,
        Standtage1: 1,
        Tageszulassung: 1,
        Taxi: 1,
        DateTechnikOK: 15,
        Trackingdaten: 1,
        TSN: 1,
        Doors: 1,
        NumDamages: 1,
        DateValuta: 1,
        DateVerkaufsfertig: 1,
        VK: 1,
        DateVerkauft: 1,
        Verkaufer: 1,
        Verwendung: 1,
        Vorbesitzer: 1,
        UsageVorfuehrwagen: 1,
        PreDamages: 1,
        VKWebBrutto: 1,
        VKWebd_netto_brutto: 1,
        MinderPreis_netto_brutto: 1,
        Youngtimer: 1,
        DateTakeInPlan: 1,
        DateTakeInReal: 1,
        ZulGesamtGewicht: 1,
        Zustand: 1,
        UeberfuehrungsPreis_netto_brutto: 1,
        miFzgWerkstatt: 1,
        fzgStatistik: 1,
    },
    'Buchhaltung': {
        IdPolsterung: 1,
        IdGrundfarbe: 1,
        Status: 1,
        IdMotor: 15,
        Schadstoffnorm: 15,
        Achsen: 15,
        Aktenzeichen: 15,
        Antrieb: 15,
        Sitze: 15,
        AUDate: 15,
        PreparePreis_netto_brutto: 15,
        Ident: 31,
        Design: 15,
        DateAuslieferung: 15,
        Ausstattungen: 15,
        Farbe: 15,
        VerbrauchAusserorts: 15,
        IdValuta: 15,
        BasisPreis_netto_brutto: 15,
        ManufactYear: 15,
        Bemerkung: 15,
        PreDamageDesc: 15,
        BestellKey: 15,
        Bewerter: 15,
        BewertungssystemStr: 15,
        BlickfangMobile: 15,
        Breite: 15,
        CO2Emission: 15,
        DateDatenCheck: 15,
        DateRechnungOut: 15,
        DateRechnungIn: 15,
        DesignNeu: 15,
        Paket: 15,
        DateEingangscheck: 15,
        EK_netto_brutto: 15,
        Einkaufer: 15,
        Envkv: 15,
        EZ: 15,
        AssEstimation: 15,
        UsageEuromobil: 15,
        Fahrbereit: 15,
        ChassisNo: 15,
        Fahrschule: 15,
        DateCreated: 15,
        KFZBrief: 15,
        Kategorie: 15,
        IdAufbau: 15,
        AktTyp: 15,
        Garantie: 15,
        DateGekauft: 15,
        AdditionalUsage: 15,
        Getriebe: 15,
        Siegel: 15,
        Hersteller: 15,
        HerstellerObj: 15,
        HSN: 15,
        HUDate: 15,
        Hubraum: 15,
        ResellerPreis_netto_brutto: 15,
        ResellerPreis2_netto_brutto: 15,
        Hoehe: 15,
        DateAufbereitung: 15,
        DateLack: 15,
        DateWerkstatt: 15,
        Innenfarbe: 15,
        VerbrauchInnerorts: 15,
        RepairPreis_netto_brutto: 15,
        Kennzeichen: 15,
        Mileage: 15,
        VerbrauchKombiniert: 15,
        Kommission: 15,
        AssKorrektion: 15,
        VK_netto_brutto: 15,
        DateLackOK: 15,
        Lackart: 15,
        Leistung: 15,
        LetzteBewertung: 15,
        Lieferzeit: 15,
        Laenge: 15,
        Mietwagen: 15,
        VKM_netto_brutto: 15,
        Modell: 15,
        ModellObj: 15,
        ModellJahr: 15,
        MWST: 15,
        Maengel: 15,
        DateNachakquise: 15,
        Neupreis_netto_brutto: 15,
        NummerRechnungOut: 15,
        NummerRechnungIn: 15,
        NurExport: 15,
        NurHaendler: 15,
        Nutzlast: 15,
        Oldtimer: 15,
        DateOptikOK: 15,
        Plakette: 15,
        Polsterung: 15,
        DatePreisOK: 15,
        Radstand: 15,
        Reifen: 15,
        AktReservation: 15,
        Scheckheft: 15,
        Schlafplaetze: 15,
        Parkplatz: 15,
        Damages: 15,
        SeiteEinsMobile: 15,
        UsageElseInfo: 15,
        UsageElse: 15,
        Standort: 15,
        Standtage2: 15,
        Standtage1Rechnung: 15,
        Standtage1: 15,
        Tageszulassung: 15,
        Taxi: 15,
        DateTechnikOK: 15,
        Trackingdaten: 15,
        TSN: 15,
        Doors: 15,
        NumDamages: 15,
        DateValuta: 15,
        DateVerkaufsfertig: 15,
        VK: 15,
        DateVerkauft: 15,
        Verkaufer: 15,
        Verwendung: 15,
        Vorbesitzer: 15,
        UsageVorfuehrwagen: 15,
        PreDamages: 15,
        VKWebBrutto: 15,
        VKWebd_netto_brutto: 15,
        MinderPreis_netto_brutto: 15,
        Youngtimer: 15,
        DateTakeInPlan: 15,
        DateTakeInReal: 15,
        ZulGesamtGewicht: 15,
        Zustand: 15,
        UeberfuehrungsPreis_netto_brutto: 15,
        miFzgKomplett: 1,
        fzgPreise: 1,
        fzgStatistik: 1,
        Provision: 1,
        ProvisionComplete: 1,
        soldAllMember: 1,
        miVerkauf: 1,
        miEditVerkauf: 1,
    },
    'eMail-Master': {
        IdPolsterung: 1,
        IdGrundfarbe: 1,
        Status: 1,
        IdMotor: 1,
        Schadstoffnorm: 1,
        Achsen: 1,
        Aktenzeichen: 1,
        Antrieb: 1,
        Sitze: 1,
        AUDate: 1,
        PreparePreis_netto_brutto: 1,
        Ident: 1,
        Design: 1,
        DateAuslieferung: 1,
        Ausstattungen: 1,
        Farbe: 1,
        VerbrauchAusserorts: 1,
        IdValuta: 1,
        BasisPreis_netto_brutto: 1,
        ManufactYear: 1,
        Bemerkung: 1,
        PreDamageDesc: 1,
        BestellKey: 1,
        Bewerter: 1,
        BewertungssystemStr: 1,
        BlickfangMobile: 1,
        Breite: 1,
        CO2Emission: 1,
        DateDatenCheck: 1,
        DateRechnungOut: 1,
        DateRechnungIn: 1,
        DesignNeu: 1,
        Paket: 1,
        DateEingangscheck: 1,
        EK_netto_brutto: 1,
        Einkaufer: 1,
        Envkv: 1,
        EZ: 1,
        AssEstimation: 1,
        UsageEuromobil: 1,
        Fahrbereit: 1,
        ChassisNo: 1,
        Fahrschule: 1,
        DateCreated: 1,
        KFZBrief: 1,
        Kategorie: 1,
        IdAufbau: 1,
        AktTyp: 1,
        Garantie: 1,
        DateGekauft: 1,
        AdditionalUsage: 1,
        Getriebe: 1,
        Siegel: 1,
        Hersteller: 1,
        HerstellerObj: 1,
        HSN: 1,
        HUDate: 1,
        Hubraum: 1,
        ResellerPreis_netto_brutto: 1,
        ResellerPreis2_netto_brutto: 1,
        Hoehe: 1,
        DateAufbereitung: 1,
        DateLack: 1,
        DateWerkstatt: 1,
        Innenfarbe: 1,
        VerbrauchInnerorts: 1,
        RepairPreis_netto_brutto: 1,
        Kennzeichen: 1,
        Mileage: 1,
        VerbrauchKombiniert: 1,
        Kommission: 1,
        AssKorrektion: 1,
        VK_netto_brutto: 1,
        DateLackOK: 1,
        Lackart: 1,
        Leistung: 1,
        LetzteBewertung: 1,
        Lieferzeit: 1,
        Laenge: 1,
        Mietwagen: 1,
        VKM_netto_brutto: 1,
        Modell: 1,
        ModellObj: 1,
        ModellJahr: 1,
        MWST: 1,
        Maengel: 1,
        DateNachakquise: 1,
        Neupreis_netto_brutto: 1,
        NummerRechnungOut: 1,
        NummerRechnungIn: 1,
        NurExport: 1,
        NurHaendler: 1,
        Nutzlast: 1,
        Oldtimer: 1,
        DateOptikOK: 1,
        Plakette: 1,
        Polsterung: 1,
        DatePreisOK: 1,
        Radstand: 1,
        Reifen: 1,
        AktReservation: 1,
        Scheckheft: 1,
        Schlafplaetze: 1,
        Parkplatz: 1,
        Damages: 1,
        SeiteEinsMobile: 1,
        UsageElseInfo: 1,
        UsageElse: 1,
        Standort: 1,
        Standtage2: 1,
        Standtage1Rechnung: 1,
        Standtage1: 1,
        Tageszulassung: 1,
        Taxi: 1,
        DateTechnikOK: 1,
        Trackingdaten: 1,
        TSN: 1,
        Doors: 1,
        NumDamages: 1,
        DateValuta: 1,
        DateVerkaufsfertig: 1,
        VK: 1,
        DateVerkauft: 1,
        Verkaufer: 1,
        Verwendung: 1,
        Vorbesitzer: 1,
        UsageVorfuehrwagen: 1,
        PreDamages: 1,
        VKWebBrutto: 1,
        VKWebd_netto_brutto: 1,
        MinderPreis_netto_brutto: 1,
        Youngtimer: 1,
        DateTakeInPlan: 1,
        DateTakeInReal: 1,
        ZulGesamtGewicht: 1,
        Zustand: 1,
        UeberfuehrungsPreis_netto_brutto: 1,
        master: 1,
        mailstat: 1,
    },
    'Datenimport': {
        IdPolsterung: 1,
        IdGrundfarbe: 1,
        Status: 1,
        IdMotor: 15,
        Schadstoffnorm: 15,
        Achsen: 15,
        Aktenzeichen: 15,
        Antrieb: 15,
        Sitze: 15,
        AUDate: 15,
        PreparePreis_netto_brutto: 15,
        Ident: 15,
        Design: 15,
        DateAuslieferung: 15,
        Ausstattungen: 15,
        Farbe: 15,
        VerbrauchAusserorts: 15,
        IdValuta: 15,
        BasisPreis_netto_brutto: 15,
        ManufactYear: 15,
        Bemerkung: 15,
        PreDamageDesc: 15,
        BestellKey: 15,
        Bewerter: 15,
        BewertungssystemStr: 15,
        BlickfangMobile: 15,
        Breite: 15,
        CO2Emission: 15,
        DateDatenCheck: 15,
        DateRechnungOut: 15,
        DateRechnungIn: 15,
        DesignNeu: 15,
        Paket: 15,
        DateEingangscheck: 15,
        EK_netto_brutto: 15,
        Einkaufer: 15,
        Envkv: 15,
        EZ: 15,
        AssEstimation: 15,
        UsageEuromobil: 15,
        Fahrbereit: 15,
        ChassisNo: 15,
        Fahrschule: 15,
        DateCreated: 15,
        KFZBrief: 15,
        Kategorie: 15,
        IdAufbau: 15,
        AktTyp: 15,
        Garantie: 15,
        DateGekauft: 15,
        AdditionalUsage: 15,
        Getriebe: 15,
        Siegel: 15,
        Hersteller: 15,
        HerstellerObj: 15,
        HSN: 15,
        HUDate: 15,
        Hubraum: 15,
        ResellerPreis_netto_brutto: 15,
        ResellerPreis2_netto_brutto: 15,
        Hoehe: 15,
        DateAufbereitung: 15,
        DateLack: 15,
        DateWerkstatt: 15,
        Innenfarbe: 15,
        VerbrauchInnerorts: 15,
        RepairPreis_netto_brutto: 15,
        Kennzeichen: 15,
        Mileage: 15,
        VerbrauchKombiniert: 15,
        Kommission: 15,
        AssKorrektion: 15,
        VK_netto_brutto: 15,
        DateLackOK: 15,
        Lackart: 15,
        Leistung: 15,
        LetzteBewertung: 15,
        Lieferzeit: 15,
        Laenge: 15,
        Mietwagen: 15,
        VKM_netto_brutto: 15,
        Modell: 15,
        ModellObj: 15,
        ModellJahr: 15,
        MWST: 15,
        Maengel: 15,
        DateNachakquise: 15,
        Neupreis_netto_brutto: 15,
        NummerRechnungOut: 15,
        NummerRechnungIn: 15,
        NurExport: 15,
        NurHaendler: 15,
        Nutzlast: 15,
        Oldtimer: 15,
        DateOptikOK: 15,
        Plakette: 15,
        Polsterung: 15,
        DatePreisOK: 15,
        Radstand: 15,
        Reifen: 15,
        AktReservation: 15,
        Scheckheft: 15,
        Schlafplaetze: 15,
        Parkplatz: 15,
        Damages: 15,
        SeiteEinsMobile: 15,
        UsageElseInfo: 15,
        UsageElse: 15,
        Standort: 15,
        Standtage2: 15,
        Standtage1Rechnung: 15,
        Standtage1: 15,
        Tageszulassung: 15,
        Taxi: 15,
        DateTechnikOK: 15,
        Trackingdaten: 15,
        TSN: 15,
        Doors: 15,
        NumDamages: 15,
        DateValuta: 15,
        DateVerkaufsfertig: 15,
        VK: 15,
        DateVerkauft: 15,
        Verkaufer: 15,
        Verwendung: 15,
        Vorbesitzer: 15,
        UsageVorfuehrwagen: 15,
        PreDamages: 15,
        VKWebBrutto: 15,
        VKWebd_netto_brutto: 15,
        MinderPreis_netto_brutto: 15,
        Youngtimer: 15,
        DateTakeInPlan: 15,
        DateTakeInReal: 15,
        ZulGesamtGewicht: 15,
        Zustand: 15,
        UeberfuehrungsPreis_netto_brutto: 15,
        miFzgKomplett: 1,
        miUploadMymotion: 1,
        statUploadMM: 1,
    },
    'Umbucher': {
        umbuchen: 1,
    },
};
export default sProfile;
